export const timeToReadByTotalWords = (totalWordCount?: number) => {
  if (!totalWordCount) return '0 мин';
  const totalWords = totalWordCount;
  const wordsPerMinute = 200;
  const minutes = Math.floor((totalWords || 0) / wordsPerMinute);
  const hoursMinutesString =
    minutes > 60 ? `${Math.floor(minutes / 60)} ч ${minutes % 60} мин` : `${minutes} мин`;
  return hoursMinutesString;
};
